/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chats_Create_Chat_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to create chat. Please try again." |
*
* @param {Chats_Create_Chat_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chats_create_chat_error = /** @type {((inputs?: Chats_Create_Chat_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chats_Create_Chat_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Erstellen des Chats. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to create chat. Please try again.")
});